export enum newTemplateFilterEnum {
    folder = "folder",
    docset = "docset",
    file = "file",
}